import { ActionType, createAction } from 'typesafe-actions'

import { Notification, NotificationTemplate, NotificationsStats } from './types'

export const AccountNotificationsActions = {
  fetchNotifications: createAction('ACCOUNT-NOTIFICATIONS/fetch-notifications')<{
    page: number
    pageSize: number
  }>(),
  setNotifications: createAction('ACCOUNT-NOTIFICATIONS/set-notifications')<{
    page: number
    totalPages: number
    data: Notification[]
  }>(),
  fetchNotificationTemplates: createAction('ACCOUNT-NOTIFICATIONS/fetch-notification-templates')(),
  setNotificationTemplates: createAction('ACCOUNT-NOTIFICATIONS/set-notification-templates')<{
    data: NotificationTemplate[]
  }>(),
  fetchNotificationsStats: createAction('ACCOUNT-NOTIFICATIONS/fetch-notifications-stats')(),
  setNotificationsStats: createAction('ACCOUNT-NOTIFICATIONS/set-notifications-stats')<NotificationsStats>(),
  markAllNotificationsAsRead: createAction('ACCOUNT-NOTIFICATIONS/mark-all-as-read')()
}

export type AccountNotificationsActions = ActionType<typeof AccountNotificationsActions>
